import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import Header from '../../components/Header';
import { tokens } from '../../theme';
import SamTimelineTable from '../../components/sam/SamTimelineTable';

const SamTimeline: FC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      <Header
        title="SAM Timeline"
        subtitle="FT-Mailings über Iterable je Versand (Webinar & PLX): Anfos, CPA-Wert, bezahlter Umsatz"
      />
      <Box
        display="grid"
        gridTemplateColumns="1fr"
        gap="20px"
        sx={{
          backgroundColor: colors.primary[400],
          padding: '20px',
          borderRadius: '8px',
        }}
      >
        <SamTimelineTable />
      </Box>
    </Box>
  );
};

export default SamTimeline;
